import { isIE } from '@jfs/utils'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { getWindow, isIFrame } from '../../utils'
import { CHILD_STATUS_CHECK_TIMEOUT, NETBANKING_RURL_HOST_NAME } from '../../utils/constants'

interface ChildWindowProps {
  hide: boolean
  retUrl: string
  childRef: any
}

function merge_options(obj1, obj2) {
  var obj3 = {}
  for (var attrname in obj1) {
    if (obj1.hasOwnProperty(attrname)) {
      obj3[attrname] = obj1[attrname]
    }
  }
  for (var attrname in obj2) {
    if (obj2.hasOwnProperty(attrname)) {
      obj3[attrname] = obj2[attrname]
    }
  }
  return obj3
}

function paramsToObject(entries) {
  var result = {}
  entries.forEach(function (value, key) {
    result[key] = value
  })
  return result
}
function queryToObject(search) {
  var urlParams = new URLSearchParams(search)
  return paramsToObject(urlParams)
}

String.prototype.stringStartsWith = function (str) {
  if (this.indexOf(str) === 0) {
    return true
  } else {
    return false
  }
}

export function useInterval(callback: unknown, delay: number | null): void {
  const savedCallback: any = useRef()
  const timerRef = useRef<any>()
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    const tick = () => {
      const completed = savedCallback?.current()
      if (completed) {
        clearInterval(timerRef.current)
      }
    }
    if (delay !== null) {
      clearInterval(timerRef.current)
      timerRef.current = setInterval(tick, delay)
      return () => clearInterval(timerRef.current)
    } else {
      clearInterval(timerRef.current)
    }
    return undefined
  }, [delay])
}

const ChildWindow: FC<ChildWindowProps> = ({ hide = true, retUrl, childRef }: ChildWindowProps) => {
  const [delay, setDelay] = useState<number | null>(null)
  const { encodedIntegrationType, encodedPayLoad, txnId, intentId, cancelIntent, uniqueWindowId } = useStores(
    (root) => ({
      encodedPayLoad: root.transaction.getEncodedPayLoad(),
      encodedIntegrationType: root.transaction.getEncodedIntegrationType(),
      txnId: root.transaction.id.id,
      intentId: root.transaction.id.intentId,
      cancelIntent: root.cancelIntentApi,
      uniqueWindowId: root.config.uniqueWindowId,
    }),
  )

  const [lazyCancelIntent, { state: cancelIntentState }] = useLazyApiData(cancelIntent)
  const { REACT_APP_ENDPOINT = '' } = process.env

  const urlToRedirect = `${REACT_APP_ENDPOINT}/redirectToBank?integrationType=${encodedIntegrationType}&payLoad=${encodedPayLoad}`
  console.log('*****  urlToRedirect: ', urlToRedirect)

  let width = 630,
    height = 440,
    top = 0,
    left = 20 // default sizes

  if (window.screen) {
    width = (window.screen.availWidth * 80) / 100
    height = (window.screen.availHeight * 80) / 100
    top = window.outerHeight / 2 + window.screenY - height / 2
    left = window.outerWidth / 2 + window.screenX - width / 2
  }

  const windowConfig = `toolbar=0,status=0,width=${width},height=${height}, top=${top}, left=${left}`
  const windowClosed = () => window.currentChild?.closed

  const child = childRef

  useEffect(() => {
    if (cancelIntentState === 'fulfilled' || cancelIntentState === 'rejected') {
      if (isIFrame()) {
        window.parent.postMessage(
          {
            txnId,
            intentId,
            status: 'cancelled',
            message: '',
          },
          '*',
        )
      } else {
        NavigateToMerchant()
      }
    }
  })

  const urlRecieved = () => {
    try {
      console.log('urlRecieved =====> PathName', window.currentChild?.location?.pathname)
      console.log('HOSTNAME', NETBANKING_RURL_HOST_NAME)
      return window.currentChild?.location?.pathname === NETBANKING_RURL_HOST_NAME
    } catch (err) {}
    return false
  }
  const checkStatus = () => {
    if (windowClosed()) {
      setDelay(null)
      lazyCancelIntent()
      return true
    }
    if (urlRecieved()) {
      window.currentChild?.close()
      setDelay(null)
      if (isIFrame()) {
        window.parent.postMessage(
          {
            txnId,
            intentId,
            status: 'completed',
            message: '',
            rUrl: retUrl,
          },
          '*',
        )
      } else {
        NavigateToMerchant()
      }
      return true
    }
    return false
  }

  const NavigateToMerchant = useCallback(() => {
    // Linking.openURL(retUrl)
    window.location.href = retUrl
  }, [retUrl])

  useEffect(() => {
    window.addEventListener(
      'message',
      function (event) {
        if (getWindow().JioPaymentWebViewInterface) {
          if (event?.data.event === 'CLOSE_CHILD_WINDOW') {
            console.log('event is : ', event)
            window.jiopayCloseChildWindow()
          }
        }
      },
      false,
    )
  }, [])

  useInterval(checkStatus, delay)

  useEffect(() => {
    if (!hide) {
      // if (isIE()) {
      //   child.current = window.open(urlToRedirect, 'jiopayWindow', windowConfig)
      //   setDelay(CHILD_STATUS_CHECK_TIMEOUT)
      // } else {
      //Opening blank url as IN IE  we are not getting child reference if you open directly
      // console.log('+++++++ urlToRedirect: ', urlToRedirect)
      // window.currentChild.location = urlToRedirect
      // setDelay(CHILD_STATUS_CHECK_TIMEOUT)
      if (isIE()) {
        child.current = window.open(urlToRedirect, 'jiopayWindow', windowConfig)
        setDelay(CHILD_STATUS_CHECK_TIMEOUT)
        return
      }
      const urlParams = new URLSearchParams(`?integrationType=${encodedIntegrationType}&payLoad=${encodedPayLoad}`)
      const payObj = {}
      urlParams.forEach(function (value, key) {
        const modKey = key.stringStartsWith('?') ? key.substring(1) : key
        try {
          payObj[modKey] = JSON.parse(value)
        } catch (e) {
          payObj[modKey] = {}
        }
      })
      let payload = payObj.payLoad ? payObj.payLoad : {}
      if (payObj.integrationType.method.toUpperCase() === 'GET') {
        const paramString = payObj.integrationType.rUrl.split('?')[1]
        if (paramString) {
          const queryObject = queryToObject(paramString)
          payload = merge_options(payload, queryObject)
        }
      }
      // The rest of this code assumes you are not using a library.
      // It can be made less verbose if you use one.
      const form = document.createElement('form')
      form.method = payObj.integrationType.method
      form.enctype = payObj.integrationType.contentType
      if (isIFrame()) {
        form.target = `jiopayWindow-${uniqueWindowId}`
      }
      form.action = payObj.integrationType.rUrl

      for (const key in payload) {
        if (payload.hasOwnProperty(key)) {
          var hiddenField = document.createElement('input')
          hiddenField.type = 'hidden'
          hiddenField.name = key
          hiddenField.value = payload[key]
          form.appendChild(hiddenField)
        }
      }

      document.body.appendChild(form)
      form.submit()
      setDelay(CHILD_STATUS_CHECK_TIMEOUT)
      // }
    }
  }, [child, encodedIntegrationType, encodedPayLoad, hide, uniqueWindowId, urlToRedirect, windowConfig])
  return null
}

export { ChildWindow }
